import { ActionTypes } from './action-types.enum';

// eslint-disable-next-line import/prefer-default-export
export const updateUser = (content) => ({
  type: ActionTypes.UPDATE_USER,
  payload: {
    user: content,
  }
});
